"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _global = _interopRequireDefault(require("global"));
var _FormWrap = _interopRequireDefault(require("./FormWrap"));
var _Input = _interopRequireDefault(require("./Input"));
var _Select = _interopRequireDefault(require("./Select"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var _analytics = _interopRequireWildcard(require("../../helpers/analytics"));
var _formatting = require("../../helpers/formatting");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CustomInputRow = /*#__PURE__*/function (_Component) {
  function CustomInputRow(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomInputRow);
    _this = _callSuper(this, CustomInputRow, [props]);
    (0, _defineProperty2["default"])(_this, "initializeState", function (fields) {
      var initialState = {};
      fields.forEach(function (field) {
        initialState[field.name] = field.defaultValue || '';
      });
      initialState.showNotification = false;
      initialState.submitting = false;
      initialState.notificationMessage = null;
      return initialState;
    });
    (0, _defineProperty2["default"])(_this, "onInputChange", function (e) {
      return _this.setState((0, _defineProperty2["default"])({}, e.target.name, e.target.value));
    });
    (0, _defineProperty2["default"])(_this, "handleSubmit", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
        postTo = _this$props.postTo,
        extraBodyProps = _this$props.extraBodyProps,
        fields = _this$props.fields;
      var formData = {};
      fields.forEach(function (field) {
        formData[field.name] = _this.state[field.name].trim();
      });
      var isEmailValid = (0, _formatting.validateEmail)(_this.state.email);
      if (!isEmailValid) {
        return _this.setState({
          submitting: false,
          notificationMessage: 'Please enter a valid email address',
          notificationType: 'error',
          showNotification: true
        });
      }
      if (_global["default"].fbq) {
        _global["default"].fbq('trackCustom', 'Signup', {
          email: _this.state.email
        });
      }
      _this.setState({
        submitting: true
      });
      fetch(postTo, {
        method: 'POST',
        body: JSON.stringify(_objectSpread(_objectSpread({}, extraBodyProps), formData)),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        var notificationType = 'error';
        if (response.status === 'success') {
          notificationType = 'success';
          _analytics["default"].contactSubscribe(formData);
        }
        _this.setState({
          notificationType: notificationType,
          showNotification: true,
          submitting: false
        });
      });
    });
    _this.state = _this.initializeState(props.fields);
    return _this;
  }
  (0, _inherits2["default"])(CustomInputRow, _Component);
  return (0, _createClass2["default"])(CustomInputRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        successMessage = _this$props2.successMessage,
        errorMessage = _this$props2.errorMessage,
        fullWidth = _this$props2.fullWidth,
        subscribeButtonText = _this$props2.subscribeButtonText,
        fields = _this$props2.fields;
      var _this$state = this.state,
        showNotification = _this$state.showNotification,
        notificationType = _this$state.notificationType,
        notificationMessage = _this$state.notificationMessage;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notificationType !== 'success' && /*#__PURE__*/_react["default"].createElement(_FormWrap["default"], {
        id: _analytics.GA4_TRIGGERS.SIGNUP_FORM_ID,
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, fields.map(function (field) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: field.name,
          className: fullWidth ? 'width-100%' : 'col-6@md'
        }, field.type === 'select' ? /*#__PURE__*/_react["default"].createElement(_Select["default"], {
          id: field.name,
          name: field.name,
          placeholder: field.placeholder,
          label: field.label,
          labelHidden: field.labelHidden,
          options: field.options.map(function (o) {
            return {
              value: o,
              text: o
            };
          }),
          value: _this2.state[field.name],
          onChange: _this2.onInputChange
        }) : /*#__PURE__*/_react["default"].createElement(_Input["default"], {
          type: field.type,
          placeholder: field.placeholder,
          label: field.label,
          name: field.name,
          onChange: _this2.onInputChange,
          value: _this2.state[field.name],
          labelHidden: field.labelHidden
        }));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: fullWidth ? 'width-100%' : 'col-6@md'
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        type: "submit",
        text: this.state.submitting ? 'Submitting' : subscribeButtonText,
        buttonType: this.state.submitting ? _constants.BUTTON_TYPES.DISABLED : _constants.BUTTON_TYPES.PRIMARY,
        buttonSize: "btn--md",
        fullWidth: true
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "max-width-sm margin-auto"
      }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        show: showNotification,
        text: notificationType === 'success' ? successMessage : notificationMessage || errorMessage,
        onClose: function onClose() {
          return _this2.setState({
            showNotification: false
          });
        },
        type: notificationType
      })));
    }
  }]);
}(_react.Component);
CustomInputRow.propTypes = {
  postTo: _propTypes["default"].string.isRequired,
  extraBodyProps: _propTypes["default"].object,
  successMessage: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  subscribeButtonText: _propTypes["default"].string,
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string,
    label: _propTypes["default"].string,
    labelHidden: _propTypes["default"].bool,
    options: _propTypes["default"].arrayOf(_propTypes["default"].string),
    defaultValue: _propTypes["default"].string
  })).isRequired
};
CustomInputRow.defaultProps = {
  extraBodyProps: {},
  errorMessage: 'Something went wrong, please try again later',
  subscribeButtonText: 'Subscribe'
};
var _default = exports["default"] = CustomInputRow;